import { api } from "@/api/axios.ts";
import { ApiTodayResult } from "@/types/employees/employee-today.types.ts";

export const apiEmployeeToday = {
  getToday() {
    return api.get<ApiTodayResult>("/api/v1/employees/today");
  },
};
